export default __webpack_public_path__ + "static/media/talent_combat_2.05320011.png";